import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { isNotDefined } from '@hsp/utilities';

import { userService } from 'services';
import { FilterForm } from 'types/pages';
import { IApplicationState } from 'types/store/application';

export const initialState: IApplicationState = {
  // bluebookFilter: undefined,
  filter: undefined,
  maxDataPoints: Number(process.env.REACT_APP_MAX_ALLOWED_DATA_POINTS ?? 100),
  maxRfmGroups: Number(process.env.REACT_APP_MAX_RFM_GROUPS),
  maxVisible: Number(process.env.REACT_APP_MAX_VISIBLE ?? 50),
  myAudiences: true,
  myLists: true,
  myMasterFiles: true,
  myNlsOrders: true,
  myPrebuilts: true,
  notificationUnreadOnly: false,
  passwordRules: [],
};

export const getPasswordRules = createAsyncThunk('application', async () => {
  const result = await userService.passwordRules();

  if (isNotDefined(result) || result.failure) {
    return [];
  }

  return [...(result.dataContainer ?? [])];
});

export const applicationSlice = createSlice({
  extraReducers: (builder) => {
    builder.addCase(getPasswordRules.fulfilled, (state, { payload: data }) => {
      state.passwordRules = data;
    });
    builder.addCase(getPasswordRules.pending, (state) => {
      state.passwordRules = [];
    });
    builder.addCase(getPasswordRules.rejected, (state) => {
      state.passwordRules = [];
    });
  },
  initialState,
  name: 'application',
  reducers: {
    reset: () => initialState,
    // setBluebookFilters: (state, { payload }: PayloadAction<BluebookFilterForm>) => {
    //   state.bluebookFilter = payload;
    // },
    setFilters: (state, { payload }: PayloadAction<FilterForm>) => {
      state.filter = payload;
    },
    setMyAudiences: (state, { payload }: PayloadAction<boolean>) => {
      state.myAudiences = payload;
    },
    setMyLists: (state, { payload }: PayloadAction<boolean>) => {
      state.myLists = payload;
    },
    setMyMasterFile: (state, { payload }: PayloadAction<boolean>) => {
      state.myMasterFiles = payload;
    },
    setMyNlsOrders: (state, { payload }: PayloadAction<boolean>) => {
      state.myNlsOrders = payload;
    },
    setMyPrebuilts: (state, { payload }: PayloadAction<boolean>) => {
      state.myPrebuilts = payload;
    },
    setNotificationUnreadOnly: (state, { payload }: PayloadAction<boolean>) => {
      state.notificationUnreadOnly = payload;
    },
  },
});

export const applicationReducer = applicationSlice.reducer;
